const videoRegex = /^(https?|ftp):\/\/[^\s\/$.?#].[^\s]*\.(mp4|avi|mpg)(\?[^\s]*)?$/

export default videoRegex